export default __webpack_public_path__ + "static/media/knowledge_icon.28c770bd.svg";